import type { TaskPayReportItemType } from '@econtractor/types';

export interface TaskBindingLabel {
    kind: string;
    name: string;
}

const bindingKey = (row: TaskPayReportItemType): string => {
    if (row.binding === 'lead') return 'lead';
    if (row.binding === 'sale') return 'sale';
    if (row.binding === 'service') return 'service';
    if (row.binding === 'personal') return 'personal';
    return 'object';
};

export const formatTaskBinding = (
    row: TaskPayReportItemType,
    t: (key: string) => string,
): TaskBindingLabel => {
    const kind = t(`Tasks:fields.${bindingKey(row)}`);
    if (row.binding === 'personal') return { kind, name: '' };
    return { kind, name: String(row.bindingName || '').trim() || '—' };
};
